import React from "react";

class TentPoles extends React.Component {
    render() {
        return (
            <div className="tent-poles container row">
                <div className="tentpole tentpole-1 col-lg-4 col-md-4 col-sm-4 col-xs-12 margin-b-l">
                    <div className="tentpole-img-container">
                        <img
                            src={require("../../img/email/tentpole_ulimitedhand@2x.png")}
                            width="80"
                            height="80"
                            alt="Unlimited royalty–free icons with NounPro"
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Over 1 Million icons,
                            <br /> royalty–free
                        </p>
                        <a
                            className="call-to-action weight-light font-small text-link"
                            href="/pricing/"
                            title="Learn about NounPro"
                        >
                            Learn more
                        </a>
                    </div>
                </div>
                <div className="tentpole tentpole-2 col-lg-4 col-md-4 col-sm-4 col-xs-12  margin-b-l">
                    <div className="tentpole-img-container display-flex margin-t-l">
                        <img
                            src={require("../../img/homepage/app_icons@2x.png")}
                            width="174"
                            height="59"
                            alt="Noun Project apps"
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Get icons in
                            <br />
                            your workflow
                        </p>
                        <span className="call-to-action weight-light font-small">
                            <a
                                className="text-link"
                                href="/apps/"
                                title="Learn more about Noun Project apps"
                            >
                                Check out the apps
                            </a>
                        </span>
                    </div>
                </div>
                <div className="tentpole tentpole-3 col-lg-4 col-md-4 col-sm-4 col-xs-12 margin-b-l">
                    <div className="tentpole-img-container">
                        <img
                            src={require("../../img/homepage/noun_customize_icons.gif")}
                            width="100"
                            height="100"
                            alt="Customize an icon"
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Customize any icon
                            <br />
                            for the perfect fit
                        </p>
                        <a
                            className="call-to-action weight-light font-small text-link"
                            href="/preview/customize/"
                            title="Try it out"
                        >
                            Try it out
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = TentPoles;
